"use client"

import { motion } from "framer-motion"
import { useRouter } from "next/navigation"

const ARCHETYPES = [
  {
    name: "The Alchemist",
    constellation: "Phoenix",
    domain: "transformation",
    narrative:
      "Your mind operates like a conceptual forge — pulling materials from distant domains and subjecting them to enough heat that they fuse into something genuinely new.",
    nearestStar: "Hedy Lamarr",
  },
  {
    name: "The Weaver",
    constellation: "Loom",
    domain: "connection",
    narrative:
      "Every conversation you have becomes a thread in something larger. You don't think in topics — you think in relationships between topics. Your mind is a textile, not a filing cabinet.",
    nearestStar: "Ursula K. Le Guin",
  },
]

export function ArchetypeGallery() {
  const router = useRouter()

  return (
    <section
      className="px-6 py-20"
      style={{ backgroundColor: "var(--brand-night-sky)" }}
    >
      <motion.p
        className="mx-auto max-w-xl text-center font-[var(--font-instrument-serif)] text-2xl font-normal sm:text-3xl"
        style={{ color: "var(--brand-moon)" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6 }}
      >
        Every portrait tells a different story
      </motion.p>

      <div className="mx-auto mt-14 max-w-xl space-y-10">
        {ARCHETYPES.map((archetype, i) => (
          <motion.div
            key={archetype.name}
            className="rounded-xl p-8"
            style={{ backgroundColor: "var(--brand-moon)" }}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
          >
            <h3
              className="font-[var(--font-instrument-serif)] text-3xl font-normal"
              style={{ color: "var(--brand-graphite)" }}
            >
              {archetype.name}
            </h3>
            <p
              className="mt-2 text-sm"
              style={{ color: "var(--brand-cliff)" }}
            >
              {archetype.constellation} &middot; {archetype.domain}
            </p>
            <p
              className="mt-5 font-[var(--font-instrument-serif)] text-lg leading-relaxed"
              style={{ color: "var(--brand-graphite)" }}
            >
              &ldquo;{archetype.narrative}&rdquo;
            </p>
            <p
              className="mt-4 text-sm"
              style={{ color: "var(--brand-cliff)" }}
            >
              Nearest star: {archetype.nearestStar}
            </p>
          </motion.div>
        ))}
      </div>

      <div className="mx-auto mt-16 max-w-xl text-center">
        <p
          className="text-base"
          style={{ color: "var(--brand-moon)" }}
        >
          These are two of 128 figures.
          <br />
          Yours will say something you haven&apos;t heard before.
        </p>
        <button
          onClick={() => router.push("/upload")}
          className="btn-star mt-8 rounded-full px-10 py-4 text-lg"
        >
          Discover yours
        </button>
      </div>
    </section>
  )
}
